var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgListasIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;stroke:#707070;}.b{clip-path:url(#a);}.c{fill:none;}.d{fill:#00995d;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 20,
    height: 20,
    transform: "translate(5 5)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-5 -5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,0H20V20H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M6.667,13.333h6.667V15H6.667Zm0-3.333h6.667v1.667H6.667Zm5-8.333H5A1.672,1.672,0,0,0,3.333,3.333V16.667a1.664,1.664,0,0,0,1.658,1.667H15a1.672,1.672,0,0,0,1.667-1.667v-10Zm3.333,15H5V3.333h5.833V7.5H15Z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgListasIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/listasIcon.945657cf.svg";
export { ForwardRef as ReactComponent };